module.exports = __webpack_public_path__ + "static/figma-63dbeac926d1ac350b86e18323d7e7af.png";